// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '../static/css/index.css'
import '../static/font/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import element from 'element-ui'
import $ from 'jquery'
import App from './App'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import tools from './util/tools'

import api from './util/api'
import animated from 'animate.css'
// import VueTouch from 'vue-touch'


Vue.prototype.$api = api
Vue.use(animated)
Vue.use(element)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// 百度地图
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  ak: 'wR7GOMExmyf77w2nxAo71q0sDEErtIj6'
})

// Vue.use(VueTouch, {name: 'v-touch'})
//   VueTouch.config.swipe = {
//      threshold: 100 //手指左右滑动距离
// }
Vue.config.productionTip = false
Vue.prototype.$tools = tools

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    keywords: "",
    description: "",
    title: "",
    cid: 1
  },
  created() {
    this.getSeo();
    // 全局配置
    router.beforeEach((to, from, next) => {
      // Change doc title
      if (to.meta.title == 'home') {
        this.cid = 1;
      } else if (to.meta.title == 'about') {
        this.cid = 2;
      }else if (to.meta.title == 'products') {
        this.cid = 3;
      }else if (to.meta.title == 'solutions') {
        this.cid = 4;
      }else if (to.meta.title == 'news') {
        this.cid = 5;
      }else if (to.meta.title == 'contact') {
        this.cid = 6;
      }else if (to.meta.title == 'vr') {
        this.cid = 7;
      }
      sessionStorage.setItem('cid',this.cid);
      this.getSeo(this.cid);
      next();
    })
  },
  methods: {
    //获取seo
    getSeo(cid) {
      var that = this;
      if(sessionStorage.getItem('cid')){
        that.cid=sessionStorage.getItem('cid');
      }
      let data = {
        cid: that.cid
      };
      that.$api.getSeo(data).then(res => {
        if (res.status == 1) {
          that.keywords = res.data.seo_key;
          that.description = res.data.seo_des;
          that.title = res.data.seo_title;
          document.title = that.title ;
          //            document.title = to.meta.title || '拓美科技'
          document.querySelector('meta[name="Keywords"]').setAttribute('content', this.keywords)
          document.querySelector('meta[name="Description"]').setAttribute('content', this.description)
        } else {
          that.$message({
            message: res.msg+'234',
            type: "warning"
          });
        }
      });
    },
     
  },
})

// new Vue({
//   el: '#app',
//   router,
//   components: { about },
//   template: '<about/>'
// })